const SORT_SCORE = 'SCORE' // 適合度順
const SORT_TITLE_ASC = 'TITLE_ASC' // タイトル：昇順
const SORT_TITLE_DESC = 'TITLE_DESC' // タイトル：降順
const SORT_CREATOR_ASC = 'PUBLISHER_ASC' // 著者：昇順
const SORT_CREATOR_DESC = 'PUBLISHER_DESC' // 著者：降順
const SORT_ISSUED_ASC = 'COLLECTION_ASC' // 出版日：新しい順
const SORT_ISSUED_DESC = 'COLLECTION_DESC' // 出版日：古い順
const SORT_CALL_NUMBER_ASC = 'BILL_NUMBER_ASC' // 請求記号：昇順
const SORT_CALL_NUMBER_DESC = 'BILL_NUMBER_DESC' // 請求記号：降順

export const mycollectionSortList = [
  { value: SORT_SCORE },
  { value: SORT_TITLE_ASC },
  { value: SORT_TITLE_DESC },
  { value: SORT_CREATOR_ASC },
  { value: SORT_CREATOR_DESC },
  { value: SORT_ISSUED_DESC },
  { value: SORT_ISSUED_ASC },
  { value: SORT_CALL_NUMBER_ASC },
  { value: SORT_CALL_NUMBER_DESC },
]
